/**
 * @file LegalEntityAutocomplete.tsx
 * @description Autocomplete для выбора юр.лица + inline-create (phase08.5 shadcn).
 */

import { useEffect, useState } from "react";

import { Combobox, type ComboboxOption } from "../ui/combobox";
import { LegalEntityCreateDialog } from "./LegalEntityCreateDialog";
import { legalEntities, type LegalEntityDto } from "../../lib/api-customers";

interface Props {
  value: string | null;
  onChange: (id: string | null) => void;
}

export function LegalEntityAutocomplete({ value, onChange }: Props) {
  const [items, setItems] = useState<LegalEntityDto[]>([]);
  const [creating, setCreating] = useState(false);

  async function refresh() {
    try {
      setItems(await legalEntities.list());
    } catch {
      // ignore
    }
  }

  useEffect(() => {
    void refresh();
  }, []);

  const options: ComboboxOption[] = items.map((i) => ({
    value: i.id,
    label: i.displayName,
    description: i.inn
      ? `ИНН ${i.inn}${i.kpp ? ` / КПП ${i.kpp}` : ""}${!i.isActive ? " · неактивно" : ""}`
      : !i.isActive
        ? "неактивно"
        : undefined,
  }));

  return (
    <>
      <Combobox
        options={options}
        value={value}
        onChange={onChange}
        placeholder="Выбрать юр.лицо"
        searchPlaceholder="Найти по названию или ИНН"
        emptyText="Не найдено"
        createLabel="Создать новое юр.лицо…"
        onCreateClick={() => setCreating(true)}
      />
      {creating ? (
        <LegalEntityCreateDialog
          open
          onClose={() => setCreating(false)}
          onCreated={(le) => {
            setCreating(false);
            void refresh();
            onChange(le.id);
          }}
        />
      ) : null}
    </>
  );
}
